import { useEffect } from "react";
import { useLocation, useNavigate, Outlet } from "react-router";
import { useAuth } from "../../context/AuthContext";
import { useModulePermissions } from "../../context/ModulePermissionsContext";
import { agenticHomeRouteOptions, getDefaultRoute } from "@/utils/routeUtils";

export function AuthRedirects() {
  const { isAuthenticated, isLoading } = useAuth();
  const {
    permissions,
    isLoading: isPermissionsLoading,
    hasPermission,
    companyLayoutSettings,
  } = useModulePermissions();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading || isPermissionsLoading) return;

    const isLoginPage = location.pathname === "/login";

    if (isAuthenticated && isLoginPage) {
      // For aniOS users we send them to "/" so OsContext rehydrates the saved
      // workspace windows. Forcing /dashboard or /screener here would replace
      // restored state with a fresh deep-link window. Classic users still get
      // the smart fallback (initial_route -> dashboard -> first permitted).
      const prefersOs =
        typeof window !== "undefined" &&
        localStorage.getItem("ani_layout_mode") !== "classic";

      const redirectPath = prefersOs
        ? "/"
        : getDefaultRoute(
            permissions?.initial_route,
            hasPermission,
            agenticHomeRouteOptions(companyLayoutSettings.forceAniOs),
          );
      navigate(redirectPath, { replace: true });
    }
  }, [isAuthenticated, isLoading, isPermissionsLoading, location.pathname, navigate, permissions, hasPermission]);

  return <Outlet />;
}
